import { render, staticRenderFns } from "./MbClassAvatarSelect.vue?vue&type=template&id=04c526ae&scoped=true&"
import script from "./MbClassAvatarSelect.vue?vue&type=script&lang=js&"
export * from "./MbClassAvatarSelect.vue?vue&type=script&lang=js&"
import style0 from "./MbClassAvatarSelect.vue?vue&type=style&index=0&id=04c526ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c526ae",
  null
  
)

export default component.exports